import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Tabs, Tab } from 'react-bootstrap';

// Helpers de formulário
import PaymentOrdersHoursTab from './PaymentOrdersHoursTab';
import PaymentOrdersDailyInternationalTab from './PaymentOrdersDailyInternationalTab';
import PaymentOrdersDailyTab from './PaymentOrdersDailyTab';
import getLocale from '../../../i18n/getLocale';

class PaymentOrdersScheduleTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
    };

    this.locale = getLocale();

  }

  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  render() {
    var self = this;
    return (
<div>
  <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
    <Tab eventKey={1} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabHoras.tituloTab}>
      <PaymentOrdersHoursTab RequestApi={this.props.request_api} refreshHours={this.props.refreshHours}  handleAlert={this.props.handleAlert} payment_order_id={this.props.payment_order_id} payment_order_payments_hours={this.props.payment_order_payments_hours} payment_order_data={this.props.payment_order_data} />
    </Tab>
    <Tab eventKey={2} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabEscala.tabDiarias.tituloTab}>
      <PaymentOrdersDailyTab RequestApi={this.props.request_api} refreshMission={this.props.refreshMission}  handleAlert={this.props.handleAlert} payment_order_id={this.props.payment_order_id} payment_order_payments_daily={this.props.payment_order_payments_daily} payment_order_data={this.props.payment_order_data} />
    </Tab>
  </Tabs>
</div>
    );
  }
}

export default PaymentOrdersScheduleTab;



// WEBPACK FOOTER //
// ./src/Components/PaymentOrders/Elements/PaymentOrdersScheduleTab.js